import locationUSAddressNoCountryModelValidator from 'forms/shared/validators/models/location/models/usAddressNoCountry';
import locationStreetCityCountryModelValidator from 'forms/shared/validators/models/location/models/streetCityCountry';
import { DEFAULT_LATEST, DEFAULT_EARLIEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { setToStartOfMonth } from 'helpers/date';
import { isPVQForm } from 'helpers/form';
import currencyModelValidator from 'forms/shared/validators/models/currency';
import { LegalAssociationsOrganizationalItemModel } from '../../organizationalItem/types';

const legalAssociationsRightsSuppressionGroupItemValidator: ValidateJSModel<LegalAssociationsOrganizationalItemModel> = {

  Organization: { presence: true, hasValue: true },
  HasUSAddress: { presence: true, hasValue: { validator: hasYesOrNo } },
  USAddress: (value, attributes) => {
    if (attributes?.HasUSAddress?.value === 'Yes') {
      return { presence: true, location: { validator: locationUSAddressNoCountryModelValidator } };
    }
    return {};
  },
  HasForeignAddress: { presence: true, hasValue: { validator: hasYesOrNo } },
  ForeignAddress: (value, attributes) => {
    if (attributes?.HasForeignAddress?.value === 'Yes') {
      return { presence: true, location: { validator: locationStreetCityCountryModelValidator } };
    }
    return {};
  },
  HasWebpage: { presence: true, hasValue: { validator: hasYesOrNo } },
  Webpage: (value, attributes) => {
    if (attributes?.HasWebpage?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  Dates: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options?.applicantBirthdate || DEFAULT_EARLIEST), latest: DEFAULT_LATEST },
  }),
  ReasonsForStaying: (value, attributes) => {
    if (attributes?.Dates?.present === true) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  ReasonsForLeaving: (value, attributes) => {
    if (attributes?.Dates?.present === false) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  HeldPositions: { presence: true, hasValue: { validator: hasYesOrNo } },
  PositionsHeld: (value, attributes) => {
    if (attributes?.HeldPositions?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  HasMadeContributions: { presence: true, hasValue: { validator: hasYesOrNo } },
  ContributionAmount: (value, attributes, attributeName, options) => {
    if (attributes?.HasMadeContributions?.value === 'Yes') {
      if (isPVQForm(options?.formType)) {
        return {
          presence: true,
          model: {
            validator: currencyModelValidator,
          },
        };
      }
      return { presence: true, hasValue: true };
    }
    return {};
  },
  WasAwareOfViolence: { presence: true, hasValue: { validator: hasYesOrNo } },
  WasAwareOfViolenceExplaination: (value, attributes) => {
    if (attributes?.WasAwareOfViolence?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  IntendedViolence: { presence: true, hasValue: { validator: hasYesOrNo } },
  IntendedViolenceExplaination: (value, attributes) => {
    if (attributes?.IntendedViolence?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  DidUseViolence: { presence: true, hasValue: { validator: hasYesOrNo } },
  UseOfViolenceExplaination: (value, attributes) => {
    if (attributes?.DidUseViolence?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  ReasonForJoining: { presence: true, hasValue: true },
  RoleInOrg: { presence: true, hasValue: true }
};

export default legalAssociationsRightsSuppressionGroupItemValidator;
